var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"textMessages ml-2",class:_vm.IsMeSend ? 'textMessagesMe' : 'textMessagesNotMe'},[_vm._v(" "+_vm._s(_vm.message.contents)+" ")]),_c('p',{staticClass:"dateMessage",style:({'text-align': _vm.IsMeSend ? 'right' : 'left'})},[_vm._v(" "+_vm._s(_vm.message.date)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }